<template>
  <div class="alert-message" :class="color">
    <div class="d-flex align-items-center">
      <div class="circle-wrap mr-2">
        <Icon :name="icon" width="16"/>
      </div>
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertMessage",
  props: {
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>


<style scoped>

</style>